module.exports = { id: "colors", url: "/build/app/img/symbols.svg#colors", viewBox: "", toString: function() { return this.url; } };